import { useMemo } from 'react';
import { HARMONY_TEXT_TO_VOICE_TRANSLATION } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import { HARMONY_TEXT_TO_VOICE_TRANSLATION_PERMISSION } from '../constants/permissions';

const useHasAccessToCommunicatorTextToVoiceTranslation = () => {
  const hasCommunicatorTextToVoiceTranslationCapabilities = useHasCapability(
    HARMONY_TEXT_TO_VOICE_TRANSLATION,
  );
  const hasCommunicatorTextToVoiceTranslationPermission = useHasPermission(
    HARMONY_TEXT_TO_VOICE_TRANSLATION_PERMISSION,
  );
  const hasAccessToCommunicatorTextToVoiceTranslationFeature = useMemo(() => {
    return (
      !!hasCommunicatorTextToVoiceTranslationCapabilities?.hasCapability &&
      !!hasCommunicatorTextToVoiceTranslationPermission?.hasPermission
    );
  }, [
    hasCommunicatorTextToVoiceTranslationCapabilities,
    hasCommunicatorTextToVoiceTranslationPermission,
  ]);
  return hasAccessToCommunicatorTextToVoiceTranslationFeature;
};

export default useHasAccessToCommunicatorTextToVoiceTranslation;
